export enum UserRole {
  PLATFORM_EMPLOYEE = 'platform_employee',
  OPERATOR = 'operator',
  PASSENGER = 'passenger',
  ADMIN = 'admin'
}

export const USER_ROLE_IDS: Record<UserRole, number> = {
  [UserRole.PLATFORM_EMPLOYEE]: 1,
  [UserRole.OPERATOR]: 2,
  [UserRole.PASSENGER]: 3,
  [UserRole.ADMIN]: 4
};

export type RoleSource = UserRole | string | number | { userRoleID?: number | null; userRoleName?: string | null } | null | undefined;

export function normalizeUserRole(role: RoleSource): UserRole {
  if (typeof role === 'object' && role?.userRoleID) {
    return userRoleFromID(role.userRoleID);
  }

  if (typeof role === 'number') {
    return userRoleFromID(role);
  }

  const rawRole = role && typeof role === 'object'
    ? role.userRoleName
    : role;

  const normalized = String(rawRole || '')
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, '_');

  if (normalized === '1') {
    return UserRole.PLATFORM_EMPLOYEE;
  }

  if (normalized === '2') {
    return UserRole.OPERATOR;
  }

  if (normalized === '3') {
    return UserRole.PASSENGER;
  }

  if (normalized === '4') {
    return UserRole.ADMIN;
  }

  if (normalized === UserRole.ADMIN || normalized === 'platform_admin') {
    return UserRole.ADMIN;
  }

  if (normalized === UserRole.OPERATOR) {
    return UserRole.OPERATOR;
  }

  if (normalized === UserRole.PASSENGER || normalized === 'commuter') {
    return UserRole.PASSENGER;
  }

  if (
    normalized === UserRole.PLATFORM_EMPLOYEE ||
    normalized === 'employee' ||
    normalized === 'riya_shuma_employee' ||
    normalized === 'operations'
  ) {
    return UserRole.PLATFORM_EMPLOYEE;
  }

  return UserRole.PASSENGER;
}

export function isPlatformEmployee(role: RoleSource): boolean {
  return normalizeUserRole(role) === UserRole.PLATFORM_EMPLOYEE;
}

export function userRoleFromID(userRoleID: number | string | null | undefined): UserRole {
  const numericRoleID = Number(userRoleID);
  const match = Object.entries(USER_ROLE_IDS).find(([, id]) => id === numericRoleID);
  return match ? match[0] as UserRole : UserRole.PASSENGER;
}
